import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appMonthYear]'
})
export class MonthYearDirective {
  private el: HTMLInputElement;

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    let value = this.el.value.replace(/\D/g, ''); // Remove tudo que não é número

    if (value.length > 6) {
      value = value.substring(0, 6); // Limita a 6 dígitos
    }

    // Formata para MM/YYYY
    if (value.length >= 3) {
      value = value.substring(0, 2) + '/' + value.substring(2);
    }

    this.el.value = value;
  }

  @HostListener('blur')
  onBlur(): void {
    const regex = /^(0[1-9]|1[0-2])\/\d{4}$/;
    if (!regex.test(this.el.value)) {
      this.el.value = ''; // Limpa se não estiver válido
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/directive/MonthYearDirective.ts